module.exports = __webpack_public_path__ + "img/doc.6e4f077a.png";